import { memoize } from "lodash";
import { TNotification } from "./types";
import { E_NOTIFICATION_TYPE } from "./constants";

class NotiticationStore {
  async handleFirebaseNotificationBody({ body }: { body: string }) {
    const parsedBody: TNotification = JSON.parse(body);

    switch (parsedBody.type) {
      default:
        break;

      case E_NOTIFICATION_TYPE.KHATTABAT_CONVERSATION_MESSAGE:
        //here will be handled by the conversation store, so we can just show an alert for now.
        window.alert(
          JSON.stringify(
            { ...parsedBody.payload, type: parsedBody.type },
            null,
            2
          )
        );
        break;
    }
  }
}

export const getNotificationStore = memoize(
  () => {
    return new NotiticationStore();
  },
  () => 1
);

export default getNotificationStore();
